<script lang="ts" setup>
import { computed } from 'vue'

interface Tag {
  id?: string
  name: string
}

const props = withDefaults(
  defineProps<{
    tags: Tag[]
    center?: boolean
    // 最多展示的标签数
    max?: number
  }>(),
  {
    center: false,
    max: 2,
  },
)

// 统一为不带按钮的粉色文字，多个标签用 " / " 连接（对照蓝湖首页）
const tagLine = computed(() =>
  (props.tags || []).slice(0, props.max).map(t => t.name).filter(Boolean).join(' / '),
)
</script>

<template>
  <p v-if="tagLine" class="tag-line text-12px truncate" :class="{ 'text-center': center }">
    {{ tagLine }}
  </p>
</template>

<style scoped>
.tag-line {
  color: #ff5ace;
}
</style>
